import { createContext, useContext } from 'react';
import { WHATSAPP_API_INITIAL_STATE } from './WhatsappApi.constants.ts';

export const WhatsappApiContext = createContext(WHATSAPP_API_INITIAL_STATE);

export const useWhatsappApiContext = () => {
  return useContext(WhatsappApiContext);
};
